import React, { useState } from 'react';
import { ArrowUpRight, ChevronDown, Menu, X } from 'lucide-react';
import { Logo } from '../Logo';

const SOLUTION_LINKS = [
  { label: 'Clínicas y agenda', detail: 'Atención, citas y seguimiento conectados.', href: '/clinicas-centros-agenda/' },
  { label: 'Estética y belleza', detail: 'Reservas, WhatsApp y reputación.', href: '/centros-estetica-belleza/' },
  { label: 'Ventas con IA', detail: 'Oportunidades, seguimiento y control.', href: '/agentes-ventas-ia/' },
  { label: 'Software e integraciones', detail: 'Conecta las herramientas que ya utilizas.', href: '/integraciones-software-ia/' },
];

const RESOURCE_LINKS = [
  { label: 'Guías y análisis', detail: 'Procesos, comparativas e integraciones.', href: '/blog/' },
  { label: 'Preguntas frecuentes', detail: 'Capacidades, permisos y límites.', href: '/preguntas-frecuentes' },
];

type NavGroupProps = {
  label: string;
  links: Array<{ label: string; detail: string; href: string }>;
};

const DesktopNavGroup: React.FC<NavGroupProps> = ({ label, links }) => (
  <details className="marketing-nav__group">
    <summary>
      {label}
      <ChevronDown aria-hidden="true" size={15} />
    </summary>
    <div className="marketing-nav__submenu">
      {links.map((link) => (
        <a key={link.href} href={link.href}>
          <strong>{link.label}</strong>
          <span>{link.detail}</span>
        </a>
      ))}
    </div>
  </details>
);

const MobileNavGroup: React.FC<NavGroupProps & { onNavigate: () => void }> = ({ label, links, onNavigate }) => (
  <details className="marketing-nav__mobile-group">
    <summary>{label}</summary>
    <div>
      {links.map((link) => (
        <a key={link.href} href={link.href} onClick={onNavigate}>{link.label}</a>
      ))}
    </div>
  </details>
);

export const MarketingNavbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const closeMobileMenu = () => setIsOpen(false);

  return (
    <nav className="marketing-shell marketing-nav" aria-label="Navegación principal">
      <div className="marketing-nav__inner">
        <a href="/" className="marketing-nav__brand" aria-label="Áncora Automations — Inicio">
          <Logo variant="light" />
        </a>

        <div className="marketing-nav__links" aria-label="Secciones de la web">
          <a href="/#como-gestiona">Cómo trabajamos</a>
          <DesktopNavGroup label="Soluciones" links={SOLUTION_LINKS} />
          <a href="/#casos">Casos reales</a>
          <DesktopNavGroup label="Recursos" links={RESOURCE_LINKS} />
          <a href="/quienes-somos">Quiénes somos</a>
          <a href="/#pricing">Planes y precios</a>
        </div>

        <a className="marketing-nav__cta" href="/#contacto">
          Cuéntanos tu caso
          <ArrowUpRight aria-hidden="true" size={17} />
        </a>

        <button
          type="button"
          className="marketing-nav__toggle"
          aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={isOpen}
          aria-controls="marketing-mobile-menu"
          onClick={() => setIsOpen((current) => !current)}
        >
          {isOpen ? <X aria-hidden="true" size={24} /> : <Menu aria-hidden="true" size={24} />}
        </button>
      </div>

      {isOpen && (
        <div id="marketing-mobile-menu" className="marketing-nav__mobile">
          <a href="/#como-gestiona" onClick={closeMobileMenu}>Cómo trabajamos</a>
          <MobileNavGroup label="Soluciones" links={SOLUTION_LINKS} onNavigate={closeMobileMenu} />
          <a href="/#casos" onClick={closeMobileMenu}>Casos reales</a>
          <MobileNavGroup label="Recursos" links={RESOURCE_LINKS} onNavigate={closeMobileMenu} />
          <a href="/quienes-somos" onClick={closeMobileMenu}>Quiénes somos</a>
          <a href="/#pricing" onClick={closeMobileMenu}>Planes y precios</a>
          <a className="marketing-nav__mobile-cta" href="/#contacto" onClick={closeMobileMenu}>
            Cuéntanos tu caso
            <ArrowUpRight aria-hidden="true" size={17} />
          </a>
        </div>
      )}
    </nav>
  );
};
